<template>
    <div id="main">
        <loading :isLoading="isLoading || isLoadingRespostas || isLoadingGraficos" />
        <div class="page">
            <div class="novo-formulario">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('respostas-formularios') }}: {{ formFormulario.titulo }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li v-if="$route.meta.abrev === 'serv'">
                                    <a>
                                        {{ $t('prestacao-servico') }}
                                    </a>
                                </li>
                                <li v-else>
                                    <a>
                                        {{
                                            $route.meta.abrev == 'pro'
                                                ? $t('promotor')
                                                : $t('vendas')
                                        }}
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        {{
                                            $route.meta.abrev == 'pro'
                                                ? $t('relatorios')
                                                : $t('formulario')
                                        }}
                                    </a>
                                </li>
                                <li>
                                    <router-link
                                        :to="{
                                            name:
                                                $route.meta.abrev == 'pro'
                                                    ? 'formulario-respondido'
                                                    : 'ven-formulario-respondido',
                                        }"
                                        >{{ $t('respostas-formularios') }}
                                    </router-link>
                                </li>
                                <li>
                                    <a href="#" aria-current="page">{{
                                        $route.params.idFormulario
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name:
                                        $route.meta.abrev == 'pro'
                                            ? 'formulario-respondido'
                                            : $route.meta.abrev == 'serv'
                                            ? 'serv-formulario-respondido'
                                            : 'ven-formulario-respondido',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <div class="pl-4 pr-2 is-clickable" @click="exportFormularioAsCSV()">
                            <b-icon
                                type="is-primary"
                                icon="file"
                                size="is-medium"
                                class="is-medium"
                                v-tippy
                                :title="$t('msg-tooltip-csv')"
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-12 px-0 is-flex is-flex-hend">
                    <div class="is-100">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            :tooltipLabel="
                                $t('msg-campo-busca-n', {
                                    n: `${$t('pergunta')}, ${$t('resposta')}`,
                                })
                            "
                        />
                    </div>
                    <b-button
                        class="ml-2 mt-auto"
                        type="is-primary"
                        icon-right="filter"
                        @click="showFilter = true"
                        v-tippy
                        :title="$t('filtros')"
                    />
                </div>
                <ul class="nav nav-tabs nav-tabs-children">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="listaPermissoes[aba].read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="listaPermissoes[aba].read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <Graficos
                    ref="tabGraficos"
                    v-if="abasAbertas['graficos'] && listaPermissoes['graficos'].read"
                    v-show="abas[abaSelecionada] == 'graficos'"
                    @updateIsLoading="isLoadingGraficos = $event"
                    :filters="filters"
                />

                <Respostas
                    ref="tabRespostas"
                    v-if="abasAbertas['respostas'] && listaPermissoes['respostas'].read"
                    v-show="abas[abaSelecionada] == 'respostas'"
                    @updateIsLoading="isLoadingRespostas = $event"
                    @updateFilter="updateOrder"
                    :filters="filters"
                />

                <lateral-content :isLoading="isLoading" v-model="showFilter" compact footer>
                    <div class="bg p-3">
                        <div class="form-columns-fit">
                            <div class="columns is-flex-wrap">
                                <div class="column is-12">
                                    <verified-date-picker
                                        dateType="startDate"
                                        :value="dataInicialSelected"
                                        :endDate="dataFinalSelected"
                                        title="data-inicio"
                                        @input="changeStartDate"
                                        :showClean="false"
                                        required
                                        :invalid="dataInicialSelected == null"
                                        :tooltipLabel="'tooltip-intervalo-data'"
                                        :tooltipPosition="'is-right'"
                                        :tooltipType="'is-dark'"
                                        :tooltipSize="'is-large'"
                                        tooltipMultilined
                                    />
                                </div>
                                <div class="column is-12">
                                    <verified-date-picker
                                        dateType="endDate"
                                        :value="dataFinalSelected"
                                        :startDate="dataInicialSelected"
                                        title="data-fim"
                                        @input="changeEndDate"
                                        :showClean="false"
                                        required
                                        :invalid="dataFinalSelected == null"
                                    />
                                </div>
                                <div class="column is-12">
                                    <vss-select
                                        title="colaborador"
                                        v-model="usuarioSelected"
                                        :options="usuarioSelect"
                                        :loading="usuarioLoading"
                                        @search="carregarUsuario"
                                        label="nome"
                                        multiple
                                        searchable
                                        clearable
                                        :closeOnSelect="false"
                                    />
                                </div>
                                <div v-if="$route.meta.abrev != 'serv'" class="column is-12">
                                    <vss-select
                                        title="cliente"
                                        v-model="clientesSelected"
                                        :options="clienteList"
                                        :loading="clienteLoading"
                                        @search="carregarCliente"
                                        multiple
                                        searchable
                                        clearable
                                        :closeOnSelect="false"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-slot:footer-right>
                        <b-button
                            type="is-warning is-silver"
                            icon-right="backspace"
                            @click="onClearFilters()"
                            class="mr-2"
                            :disabled="isLoading"
                        >
                            {{ $t('limpar') }}
                        </b-button>
                        <b-button
                            type="is-primary"
                            icon-right="filter"
                            @click="updateFilters()"
                            :disabled="isLoading"
                        >
                            {{ $t('filtrar') }}
                        </b-button>
                    </template>
                </lateral-content>
            </div>
        </div>
    </div>
</template>

<script>
import Graficos from '@/components/promotor/relatorio/formulario/abas/Graficos.vue';
import Respostas from '@/components/promotor/relatorio/formulario/abas/Respostas.vue';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService.js';

export default {
    components: {
        Graficos,
        Respostas,
    },
    data() {
        return {
            gerenciarUsuariosService: new GerenciarUsuariosService(this.$http, this.$router),
            permissao: {},
            abaSelecionada: 0,
            abas: ['graficos', 'respostas'],
            abasAbertas: {},
            listaPermissoes: {},
            isLoading: false,
            isLoadingRespostas: false,
            isLoadingGraficos: false,
            filters: {
                searchQuery: '.*',
                idsColaboradores: [],
                idsClientes: [],
                dataInicial: this.minusWeeksDay(new Date(), 52),
                dataFinal: new Date(),
                column: 'dataHora',
                order: 'desc',
            },
            dataInicialSelected: this.minusWeeksDay(new Date(), 52),
            dataFinalSelected: new Date(),
            debouncedOnSearch: null,
            usuarioSelect: [],
            usuarioSelected: [],
            usuarioLoading: false,
            clientesSelected: [],
            clienteList: [],
            clienteLoading: false,
            showFilter: false,
            formFormulario: {
                titulo: null,
            },
        };
    },
    created() {
        if (this.$route.meta.abrev == 'serv') {
            this.permissao = this.hasPermissionAccess(
                'prestacao-servico',
                'formulario',
                'serv-formulario-respondido'
            );
        } else if (this.$route.meta.abrev == 'pro') {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'relatorios',
                'formulario-respondido'
            );
        } else if (this.$route.meta.abrev == 'ven') {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'formulario',
                'ven-formulario-respondido'
            );
        }

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });

        for (let [key, value] of Object.entries(this.abas)) {
            this.abasAbertas[value] = false;
            this.listaPermissoes[value] = this.hasPermissionAccess(
                this.$route.meta.abrev == 'serv' ? 'prestacao-servico' : 'vendas',
                'formulario',
                this.$route.meta.abrev == 'pro'
                    ? 'formulario-respondido'
                    : this.$route.meta.abrev == 'serv'
                    ? 'serv-formulario-respondido'
                    : 'ven-formulario-respondido'
            );
        }

        for (let [key, value] of Object.entries(this.listaPermissoes)) {
            if (value.read) {
                this.abaSelecionada = this.abas.findIndex((e) => e == key);
                this.abasAbertas[key] = true;
                break;
            }
        }

        if (this.$route.query.aba) {
            this.abaSelecionada = this.$route.query.aba;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        }

        this.debouncedOnSearch = this.debounce(this.onSearch, 1000);

        this.carregarDadosFormulario();
    },
    methods: {
        carregarDadosFormulario() {
            this.$axios
                .get(
                    `/${this.$route.meta.abrev}/formFormulario/${this.$route.params.idFormulario}.json`
                )
                .then((response) => {
                    this.formFormulario = response.data.content;
                })
                .catch((_) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;

            const currentQueryParams = this.$route.query;

            this.$router.push({ query: { ...currentQueryParams, aba: i } });
        },
        onSearch(value) {
            this.filters.searchQuery = value;
        },
        carregarUsuario(query = null) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.usuarioLoading = true;
            this.gerenciarUsuariosService
                .findAllComboSituacao(2, query)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idusuario,
                            idusuario: m.idusuario,
                            nome: m.situacao === 'A' ? m.nome : 'Inativo | ' + m.nome,
                            situacao: m.situacao,
                        };
                    });
                })
                .then((content) => {
                    this.usuarioSelect = content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`);
                })
                .finally((_) => {
                    this.usuarioLoading = false;
                });
        },
        carregarCliente(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.clienteLoading = true;
            this.$axios
                .get('/getcombo/cliente.json', {
                    params: {
                        situacao: 4,
                        param: query,
                    },
                })
                .then((response) => {
                    if (response.data.content) {
                        this.clienteList = response.data.content.map((m) => ({
                            id: m.idcliente,
                            label: `${m.replicapda == 2 ? 'Inativo | ' : ''}${m.nome} - ${
                                m.rsocial
                            }`,
                            replicapda: m.replicapda,
                        }));
                    }
                })
                .catch(() => {
                    console.error('Erro ao carregar cliente.');
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateFilters() {
            const idsColaboradores = this.usuarioSelected.map(
                (usuario) => usuario.idusuario
            );
            const idsClientes = this.clientesSelected.map((cliente) => cliente.id);

            this.filters = {
                ...this.filters,
                idsColaboradores,
                idsClientes,
                dataInicial: this.dataInicialSelected,
                dataFinal: this.dataFinalSelected,
            };

            this.showFilter = false;
        },

        onClearFilters() {
            this.usuarioSelected = [];
            this.clientesSelected = [];
            this.dataInicialSelected = this.minusWeeksDay(new Date(), 52);
            this.dataFinalSelected = new Date();

            this.updateFilters();
        },
        updateOrder(tableFilter) {
            this.filters = {
                ...this.filters,
                column: tableFilter.field,
                order: tableFilter.order,
            };
        },
        changeStartDate(date) {
            if (date.getTime() != this.dataInicialSelected.getTime()) {
                this.dataInicialSelected = date;

                const dateCopy = new Date(date);

                const oneYearInFuture = this.plusWeeks(dateCopy, 52);

                if (this.dataFinalSelected.getTime() > oneYearInFuture.getTime()) {
                    this.dataFinalSelected = oneYearInFuture;
                }
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.dataFinalSelected.getTime()) {
                this.dataFinalSelected = date;

                const dateCopy = new Date(date);

                const oneYearAgo = this.minusWeeksDay(dateCopy, 52);

                if (this.dataInicialSelected.getTime() < oneYearAgo.getTime()) {
                    this.dataInicialSelected = oneYearAgo;
                }
            }
        },
        minusWeeksDay(date, weeks, day = 0) {
            date.setDate(date.getDate() - 7 * weeks - day);
            return date;
        },
        plusWeeks(date, weeks) {
            date.setDate(date.getDate() + 7 * weeks);
            return date;
        },
        exportFormularioAsCSV() {
            this.isLoading = true;

            this.$axios
                .post(
                    `/${this.$route.meta.abrev}/formRespostaCabecalho/allByIdFormAndOrigem/csv`,
                    this.filters,
                    {
                        params: {
                            idFormulario: +this.$route.params.idFormulario,
                            origem: this.$route.query.origem,
                        },
                        responseType: 'blob',
                    }
                )
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));

                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        `${this.$route.params.idFormulario}_${this.formFormulario.titulo}_${this.$route.query.origem}.csv`
                    );
                    document.body.appendChild(link);
                    link.click();

                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(link);
                    }, 5000);
                })
                .catch((_) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.novo-formulario {
    display: flex;
    flex-flow: column;
    height: 100%;
}
#main {
    height: 100%;
}
.page {
    padding: 20px;
    background-color: $sovis-white;
    border-radius: 2px;

    .nav-tabs-children {
        margin-bottom: 20px;

        li > a {
            text-transform: capitalize;
        }

        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: '';
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
